import { Typo } from "../Typo";

export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Accessible name for the switch button. Defaults to `label` when omitted. */
  ariaLabel?: string;
  disabled?: boolean;
  "data-testid"?: string;
};

export const Toggle = ({
  checked,
  onChange,
  label,
  ariaLabel,
  disabled = false,
  "data-testid": testId = "toggle",
}: ToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel ?? label}
        disabled={disabled}
        data-testid={testId}
        onClick={() => onChange(!checked)}
        className={`relative inline-flex h-6 w-12 shrink-0 items-center rounded-full transition-colors ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        } ${checked ? "bg-surface-brand-default" : "bg-stroke-secondary"}`}
      >
        <span
          className={`inline-block h-5 w-5 rounded-full bg-white shadow-sm transition-transform ${
            checked
              ? "ltr:translate-x-[26px] rtl:-translate-x-[26px]"
              : "ltr:translate-x-[2px] rtl:-translate-x-[2px]"
          }`}
        />
      </button>
      {label && (
        <Typo type="labelSM" smType="labelXS">
          {label}
        </Typo>
      )}
    </div>
  );
};
